import React, {FC} from 'react'
import {Spinner} from 'react-bootstrap'

interface LoadingFallbackProps {
  height?: number
  text?: string
}

const LoadingFallback: FC<LoadingFallbackProps> = ({height = 200, text = 'Loading...'}) => (
  <div className='d-flex align-items-center justify-content-center' style={{minHeight: height}}>
    <Spinner animation='border' variant='primary' size='sm' />
    <span className='ms-3 text-muted'>{text}</span>
  </div>
)

export default LoadingFallback
